import { useRef, useEffect, useState } from "react";

export function useMouseMovement() {
  const [mouseXRef, setMouseXRef] = useState(0);
  const [mouseYRef, setMouseYRef] = useState(0);

  useEffect(() => {
    const handleMouseMove = (event: MouseEvent) => {
      const { clientX, clientY } = event;
      const viewportWidth = window.innerWidth;
      const viewportHeight = window.innerHeight;

      setMouseXRef((clientX / viewportWidth) * 2 - 1);
      setMouseYRef((clientY / viewportHeight) * 2 - 1);
    };

    window.addEventListener("mousemove", handleMouseMove);

    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
    };
  }, []);

  return { mouseX: mouseXRef, mouseY: mouseYRef };
}
